<div class="content-placeholder">
  <div class="title"></div>
  <div class="subtitle"></div>
  <div class="content-slide">
    <div class="box-content" *ngFor="let i of [].constructor(2)">
      <div class="box-header">
        <div class="title-header"></div>
        <div class="price"></div>
      </div>
      <div class="box-category">
        <div class="box-item" *ngFor="let i of [].constructor(13)">
          <div class="icon"></div>
          <div class="text"></div>
        </div>
      </div>
      <div class="box-button">
        <div class="button"></div>
      </div>
    </div>
  </div>
</div>